import { jsxs, jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import cns from '../../node_modules/classnames/index.js';
import useMouseOver from '../Hooks/useMouseOver.js';

/**
Componente che mostra un messaggio all'hover.

__DEPRECATO: utilizzare `V2/Tooltip`__

 */
function PopOver({ children, content, className = '', left = false, right = false, top = false, timeout, }) {
    const [mostraInfo, onMouseOver, onMouseOut] = useMouseOver();
    useEffect(() => {
        let timeoutId;
        if (mostraInfo && timeout > 1000) {
            timeoutId = setTimeout(onMouseOut, timeout);
        }
        return () => timeoutId && clearTimeout(timeoutId);
    }, [mostraInfo, onMouseOut, timeout]);
    const classes = cns('popover', {
        'popover--left': left,
        'popover--top': top,
        'popover--right': right,
        'popover--bottom': !right && !top && !left,
    }, className);
    return (jsxs("div", { className: classes, children: [jsx("div", { className: "popover__activearea" }), mostraInfo && content && (jsx("div", { className: "popover__content", children: jsx("div", { className: "popover__innerContent", children: content }) })), jsx("div", { className: "popover__children", onBlur: onMouseOut, onFocus: onMouseOver, onMouseEnter: onMouseOver, onMouseLeave: onMouseOut, children: children })] }));
}

export { PopOver as default };
